import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers';

const middlewares = [thunkMiddleware];

// Use process.env and process.browser instead of appConfig because we want this
// to happen during build time, whereas app configs get resolved during run time
const devInClient = process.env.NODE_ENV !== 'production' && process.browser;

const createStoreWithMiddleware = compose(
  applyMiddleware(...middlewares),
  devInClient && window.devToolsExtension
    ? window.devToolsExtension()
    : (f) => f
)(createStore);

export default (initialState) =>
  createStoreWithMiddleware(rootReducer, initialState);
